/** @format */

import {useState} from 'react';

import {Box, Container, CssBaseline, Link, IconButton, Drawer} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

import {makeStyles} from '@mui/styles';

import PaymentErrorBanner from 'components/banners/PaymentErrorBanner';
import {NoDataBannerNew} from 'components/banners/NoDataBannerNew';

import {ACTION_BANNER_Z_INDEX} from 'components/banners/ActionBanner';

import logoImg from 'images/logo_mobile.png';

import {TopMenuNew} from 'components/menus/TopMenuNew';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  menuMobile: {
    padding: theme.spacing(4, 2),
  },
  menuMobileExpandButton: {
    padding: theme.spacing(4),
    borderRadius: '8px',

    '&:hover': {
      background: 'none',
    },
  },
  drawerPaper: {
    background: theme.palette.figma_gray_dark_5?.main,
    width: '100%',
  },
  content: {
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  },
  menuBox: {
    width: '100%',
  },
  menu: {
    position: 'relative',
    zIndex: ACTION_BANNER_Z_INDEX + 1,
  },
}));

interface Props {
  children: React.ReactNode;
}

const WideLayout = (props: Props) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const classes = useStyles();

  const handleToggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const renderDrawer = () => {
    return (
      <nav>
        <Drawer
          open={isDrawerOpen}
          classes={{paper: classes.drawerPaper}}
          variant='temporary'
          anchor={'right'}
          onClose={handleToggleDrawer}
        >
          <TopMenuNew onToggleDrawer={handleToggleDrawer} />
        </Drawer>
      </nav>
    );
  };

  return (
    <Box className={classes.root}>
      <CssBaseline />
      {renderDrawer()}
      <Box
        className={classes.menuMobile}
        sx={{
          display: {xs: 'flex', md: 'none'},
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Link href='/'>
          <img alt='AdSensor Logo' height='30' src={logoImg} />
        </Link>
        <Box>
          <IconButton
            color='inherit'
            edge='start'
            onClick={handleToggleDrawer}
            className={classes.menuMobileExpandButton}
            size='large'
          >
            <MenuIcon />
          </IconButton>
        </Box>
      </Box>
      <Box className={classes.content}>
        <NoDataBannerNew />
        <PaymentErrorBanner />

        <Box className={classes.menuBox}>
          <Box
            className={classes.menu}
            sx={{
              display: {xs: 'none', md: 'block'},
            }}
          >
            <TopMenuNew />
          </Box>
        </Box>

        <Container maxWidth='xl'>{props.children}</Container>
      </Box>
    </Box>
  );
};

export default WideLayout;
